import deskMain from "./img/deskmain.png";
import mobMain from "./img/mobmain.png";

export { deskMain, mobMain };

/** Softens deskmain/mobmain so they sit subtly behind foreground art. */
const BASE_BG_OVERLAY =
  "linear-gradient(rgba(232, 238, 245, 0.25), rgba(232, 238, 245, 0.25))";

export function isMobViewport() {
  const w = window.innerWidth;
  const narrow = w > 0 && w <= 768;
  const portrait =
    window.matchMedia &&
    window.matchMedia("(orientation: portrait)").matches;
  return narrow && portrait;
}

export function getBaseStageBackground(mob = isMobViewport()) {
  return mob ? mobMain : deskMain;
}

function baseBackgroundLayers(baseUrl) {
  return `${BASE_BG_OVERLAY}, url("${baseUrl}")`;
}

/** Stage scene art: full bleed on mobile portrait, height-fit on desktop. */
export function getStageForegroundSize(mob = isMobViewport()) {
  return mob ? "100% 100%" : "auto 100%";
}

export function applyStageBodyBackground(
  body,
  {
    foregroundUrl = null,
    mob = isMobViewport(),
    plainPhase = false,
    foregroundSize,
    fixedAttachment = false,
  } = {}
) {
  const base = getBaseStageBackground(mob);
  const baseLayers = baseBackgroundLayers(base);
  const attachment = fixedAttachment ? "fixed" : mob ? "scroll" : "fixed";
  const fgSize = foregroundSize ?? getStageForegroundSize(mob);
  const sizePriority = mob ? "important" : "";

  if (foregroundUrl) {
    body.style.backgroundImage = `url("${foregroundUrl}"), ${baseLayers}`;
    body.style.backgroundRepeat = "no-repeat, no-repeat, no-repeat";
    body.style.backgroundPosition = "center center, center center, center center";
    body.style.setProperty(
      "background-size",
      `${fgSize}, 100% 100%, cover`,
      sizePriority
    );
    body.style.backgroundColor = "#dce8f5";
  } else {
    body.style.backgroundImage = baseLayers;
    body.style.backgroundRepeat = "no-repeat, no-repeat";
    body.style.backgroundPosition = "center center, center center";
    body.style.setProperty(
      "background-size",
      "100% 100%, cover",
      sizePriority
    );
    body.style.backgroundColor = plainPhase ? "#e8eef5" : "#dce8f5";
  }

  body.style.backgroundAttachment = attachment;
}

/** Login / leaderboard foreground: full bleed on mobile portrait, contain elsewhere. */
export function getAppForegroundSize(mob = isMobViewport()) {
  return mob ? "100% 100%" : "contain";
}

const APP_BODY_STYLE_KEYS = [
  "background-attachment",
  "background-size",
  "background-repeat",
  "background-position",
  "overflow-x",
  "margin",
  "padding",
  "height",
  "font-family",
];

/** Shared body background for login and leaderboard (foreground + deskmain/mobmain). */
export function setupAppPageBodyBackground(body, { deskForeground, mobForeground }) {
  const snapshot = APP_BODY_STYLE_KEYS.map((k) => [
    k,
    body.style.getPropertyValue(k),
  ]);

  body.style.setProperty("background-attachment", "fixed");
  body.style.setProperty("background-size", "contain");
  body.style.setProperty("background-repeat", "no-repeat");
  body.style.setProperty("background-position", "center");
  body.style.setProperty("overflow-x", "hidden");
  body.style.setProperty("margin", "0");
  body.style.setProperty("padding", "0");
  body.style.setProperty("height", "100vh");
  body.style.setProperty(
    "font-family",
    "'FiraSans-Medium', sans-serif",
    "important"
  );

  const apply = () => {
    const mob = isMobViewport();
    applyStageBodyBackground(body, {
      foregroundUrl: mob ? mobForeground : deskForeground,
      mob,
      foregroundSize: getAppForegroundSize(mob),
      fixedAttachment: true,
    });
  };

  apply();
  window.addEventListener("resize", apply);
  window.addEventListener("orientationchange", apply);

  return () => {
    window.removeEventListener("resize", apply);
    window.removeEventListener("orientationchange", apply);
    body.style.removeProperty("background-image");
    snapshot.forEach(([k, v]) => {
      if (v) body.style.setProperty(k, v);
      else body.style.removeProperty(k);
    });
  };
}
